export default "__VITE_ASSET__BhNVCoDI__"